import * as runtime from '@/api/runtime'
import {
  BatchOnShelfReserveListRequest,
  BatchOnShelfReserveListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchOnShelfReserveListCondition,
  BatchOnShelfReserveListConditionFromJSON
} from '@/api/models/batch/BatchOnShelfReserveListCondition'

/**
 * 帳票作成
 */
export class BatchOnShelfReserveListApi extends runtime.BaseAPI {
  async return(request: BatchOnShelfReserveListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/on-shelf-reserve-list`,
      BatchOnShelfReserveListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchOnShelfReserveListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchOnShelfReserveListConditionFromJSON(jsonValue)
    ).value()
  }
}
